import { createStyles } from '../../../../../../../../styles/helpers'

export default createStyles({
  userCanSelectProductsCheckbox: {
    marginTop: 8
  }
})
